'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  span {\n    color: ', ';\n    margin: 1px 10px 0 0 !important;\n  }\n'], ['\n  span {\n    color: ', ';\n    margin: 1px 10px 0 0 !important;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: 5px;\n  width: 98%;\n  max-height: 280px;\n  overflow: auto;\n  span {\n    margin: 0;\n    font-weight: 400;\n  }\n'], ['\n  margin-top: 5px;\n  width: 98%;\n  max-height: 280px;\n  overflow: auto;\n  span {\n    margin: 0;\n    font-weight: 400;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: 10px;\n  margin-left: 10px;\n  color: ', ';\n  cursor: pointer;\n  width: 60px;\n  font-size: 14px;\n  color: #715AFF;\n  float: left;\n'], ['\n  margin-top: 10px;\n  margin-left: 10px;\n  color: ', ';\n  cursor: pointer;\n  width: 60px;\n  font-size: 14px;\n  color: #715AFF;\n  float: left;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  border-radius: 5px;\n  border: none;\n  text-align: left;\n  padding-right: 15%;\n  &:after {\n    content: "";\n    display: table;\n    clear: both;\n  }\n  span {\n    background: ', ';\n    color: ', ';\n    border: 1px ', ' solid;\n    border-right: none;\n    padding: 0.68em;\n    border-radius: 0 5px 5px 0;\n    border-bottom: 2px #715AFF solid;\n    position: absolute;\n  }\n  input {\n    padding: 0.5em;\n    border: 1px ', ' solid;\n    border-radius: 5px 0 0 5px;\n    width: 100%;\n  }\n'], ['\n  border-radius: 5px;\n  border: none;\n  text-align: left;\n  padding-right: 15%;\n  &:after {\n    content: "";\n    display: table;\n    clear: both;\n  }\n  span {\n    background: ', ';\n    color: ', ';\n    border: 1px ', ' solid;\n    border-right: none;\n    padding: 0.68em;\n    border-radius: 0 5px 5px 0;\n    border-bottom: 2px #715AFF solid;\n    position: absolute;\n  }\n  input {\n    padding: 0.5em;\n    border: 1px ', ' solid;\n    border-radius: 5px 0 0 5px;\n    width: 100%;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 0.8em;\n  margin: 1em 0;\n  margin-bottom: -20px;\n\n  label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 8px;\n    height: 8px;\n    border: 1px solid #ddd;\n    background: #fff;\n  }\n'], ['\n  font-size: 0.8em;\n  margin: 1em 0;\n  margin-bottom: -20px;\n\n  label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 8px;\n    height: 8px;\n    border: 1px solid #ddd;\n    background: #fff;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 10px;\n  text-align: left;\n'], ['\n  margin: 10px;\n  text-align: left;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _MozartCheckBox = require('./MozartCheckBox');

var _MozartCheckBox2 = _interopRequireDefault(_MozartCheckBox);

var _MozartRadio = require('./MozartRadio');

var _MozartRadio2 = _interopRequireDefault(_MozartRadio);

var _MozartBreadCrum = require('../MozartBreadCrum');

var _MozartBreadCrum2 = _interopRequireDefault(_MozartBreadCrum);

var _MozartToolTip = require('../MozartToolTip');

var _MozartToolTip2 = _interopRequireDefault(_MozartToolTip);

var _reactVirtualized = require('react-virtualized');

var _utils = require('./../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var removeDuplicates = function removeDuplicates(myArr, prop) {
  return myArr.filter(function (obj, pos, arr) {
    return arr.map(function (mapObj) {
      return mapObj[prop];
    }).indexOf(obj[prop]) === pos;
  });
};

var MozartCheckboxLabelLevelDown = _styledComponents2.default.span(_templateObject, _color2.default.blue_accent);

var MozartfilterCheckboxContainer = _styledComponents2.default.div(_templateObject2);

var ClearAll = _styledComponents2.default.div(_templateObject3, _color2.default.t12);

var CheckAll = _styledComponents2.default.div(_templateObject3, _color2.default.t12);

var MozartFilterSearch = _styledComponents2.default.div(_templateObject4, _color2.default.blue_main, _color2.default.white, _color2.default.blue_accent, _color2.default.blue_accent);

var MozartCheckboxCustom = _styledComponents2.default.div(_templateObject5);

var BREADCRUMS = _styledComponents2.default.div(_templateObject6);

var MozartInputBox = function (_Component) {
  _inherits(MozartInputBox, _Component);

  function MozartInputBox(props) {
    _classCallCheck(this, MozartInputBox);

    var _this = _possibleConstructorReturn(this, (MozartInputBox.__proto__ || Object.getPrototypeOf(MozartInputBox)).call(this, props));

    _this.state = {
      breadcrums: [],
      search_value: ''
    };

    _this.list = [];
    _this.scrollTop = 0;
    return _this;
  }

  _createClass(MozartInputBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.filter.search_result === 'undefined') {
        this.setState({ search_value: '' });
      }
    }
  }, {
    key: 'getCheckBoxesListExpandable',
    value: function getCheckBoxesListExpandable() {
      var _this2 = this;

      var RETURN_DATA = [];

      var getCheckBoxList = function getCheckBoxList(filter) {
        var DATA = [];
        var DATASTAYFIRST = [];
        // get all children at current level
        var keys = _this2.getOrderCheckBoxesByNameKey(filter);
        if (_this2.state.search_value.trim().length < 3) {
          keys.forEach(function (key) {
            if (!filter.children[key].stayfirst) {
              DATA.push(filter.children[key]);
            } else {
              DATASTAYFIRST.push(filter.children[key]);
            }
          });
        } else {
          // search case
          if (filter.search_result && filter.search_result.length > 0) {
            filter.search_result.forEach(function (item) {
              item.expanded = false;
              item.left = 0;
              if (!item.stayfirst) {
                DATA.push(item);
              } else {
                DATASTAYFIRST.push(item);
              }
            });
          }
        }

        // new array of tree
        var currData = DATASTAYFIRST.concat(DATA);

        // find the index to reorder
        var currIndex = 0;
        RETURN_DATA.forEach(function (item, index) {
          if (String(item.id) === String(filter.id)) {
            currIndex = index;
          }
        });
        // inject current expanded selection into the correct position of tree
        var firstDATA = RETURN_DATA.slice(0, currIndex + 1);
        var lastDATA = RETURN_DATA.slice(currIndex, RETURN_DATA.length);
        RETURN_DATA = firstDATA.concat(currData.concat(lastDATA));

        if (_this2.state.search_value.trim().length < 3) {
          keys.forEach(function (key) {
            if (filter.children[key].expanded) {
              getCheckBoxList(filter.children[key], filter.children[key].name);
              Object.keys(filter.children[key].children).forEach(function (itemKey) {
                if (filter.children[key].children[itemKey].expanded) {
                  getCheckBoxList(filter.children[key].children[itemKey], filter.children[key].children[itemKey].name);
                }
              });
            }
          });
        }
      };

      var rootFilter = this.props.filter;
      while (rootFilter.parent && rootFilter.filter !== null) {
        rootFilter = rootFilter.parent;
      }

      getCheckBoxList(rootFilter);
      RETURN_DATA = removeDuplicates(RETURN_DATA, 'id');
      return RETURN_DATA.map(function (item) {
        return _this2.getCheckBox(item, item.name);
      });
    }
  }, {
    key: 'getCheckBoxesList',
    value: function getCheckBoxesList() {
      var _this3 = this;

      var _props = this.props,
          filter = _props.filter,
          name = _props.name;

      var DATA = [];
      var DATASTAYFIRST = [];
      // get all children at current level
      var keys = this.getOrderCheckBoxesByNameKey(filter);
      if (this.state.search_value.trim().length < 3) {
        keys.forEach(function (key) {
          if (!filter.children[key].stayfirst) {
            DATA.push(_this3.getCheckBox(filter.children[key], name));
          } else {
            DATASTAYFIRST.push(_this3.getCheckBox(filter.children[key], name));
          }
        });
      } else {
        // search case
        if (filter.search_result && filter.search_result.length > 0) {
          filter.search_result.forEach(function (item) {
            if (!item.stayfirst) {
              DATA.push(_this3.getCheckBox(item, name));
            } else {
              DATASTAYFIRST.push(_this3.getCheckBox(item, name));
            }
          });
        }
      }
      return DATASTAYFIRST.concat(DATA);
    }
  }, {
    key: 'getCheckBoxes',
    value: function getCheckBoxes() {
      var _this4 = this;

      var _props2 = this.props,
          infinite = _props2.infinite,
          infiniteWidth = _props2.infiniteWidth,
          infiniteHeight = _props2.infiniteHeight,
          expandable = _props2.expandable;

      this.list = !expandable ? this.getCheckBoxesList() : this.getCheckBoxesListExpandable();
      if (this.scrollTop > this.list.length * 30) {
        this.scrollTop = 0;
      }
      this.listElem = _react2.default.createElement(_reactVirtualized.List, {
        ref: 'list',
        width: infiniteWidth ? infiniteWidth : 410,
        height: infiniteHeight ? infiniteHeight : 300,
        rowCount: this.list.length,
        rowHeight: 30,
        onScroll: function onScroll(data) {
          _this4.scrollTop = data.scrollTop;
        },
        style: { maxWidth: '1500px' },
        scrollTop: this.scrollTop,
        rowRenderer: function rowRenderer(_ref) {
          var key = _ref.key,
              index = _ref.index,
              style = _ref.style;

          return _react2.default.createElement(
            'div',
            { key: key, style: style },
            _this4.list[index]
          );
        }
      });

      return infinite ? this.listElem : this.list;
    }
  }, {
    key: 'getInnerLevelIcon',
    value: function getInnerLevelIcon(id, checkboxNode) {
      var expandable = this.props.expandable;

      var style = { margin: '0px 5px', fontSize: '1.3em', fontWeight: '400', cursor: 'pointer' };
      if (!expandable && checkboxNode.children && checkboxNode.children !== null && Object.keys(checkboxNode.children).length !== 0) {
        return _react2.default.createElement(
          MozartCheckboxLabelLevelDown,
          {
            'data-hint': 'Go to next level',
            id: id + '_inner',
            className: 'hint--top',
            style: style,
            onClick: this.handleInnerLevelClick.bind(this, checkboxNode)
          },
          _react2.default.createElement('span', { className: 'icon-Down' })
        );
      }
      if (expandable && !checkboxNode.expanded && checkboxNode.children && checkboxNode.children !== null && Object.keys(checkboxNode.children).length !== 0) {
        return _react2.default.createElement(
          MozartCheckboxLabelLevelDown,
          {
            'data-hint': 'Go to next level',
            id: id + '_inner',
            className: 'hint--top',
            style: style,
            onClick: this.handleInnerLevelClick.bind(this, checkboxNode)
          },
          _react2.default.createElement('span', { className: 'icon-PlusCircle' })
        );
      }
      if (expandable && checkboxNode.expanded && checkboxNode.children && checkboxNode.children !== null && Object.keys(checkboxNode.children).length !== 0) {
        return _react2.default.createElement(
          MozartCheckboxLabelLevelDown,
          {
            'data-hint': 'Go to next level',
            id: id + '_inner',
            className: 'hint--top',
            style: style,
            onClick: this.handleInnerLevelClick.bind(this, checkboxNode)
          },
          _react2.default.createElement('span', { className: 'icon-MinusCircle' })
        );
      }

      return _react2.default.createElement('span', { style: { width: '37px', display: 'inline-block' } });
    }
  }, {
    key: 'getCheckBox',
    value: function getCheckBox(checkboxNode, filterName) {
      var _props3 = this.props,
          multipleSelect = _props3.multipleSelect,
          expandable = _props3.expandable,
          direction = _props3.direction,
          excludeSelect = _props3.excludeSelect,
          toolTipPlacement = _props3.toolTipPlacement,
          testId = _props3.testId;

      var id = checkboxNode.id + '_' + filterName.toLowerCase().split(' ').join('_');
      var name = filterName;
      var hoverText = this.getHoverText(checkboxNode);
      var defaultChecked = typeof checkboxNode.checked !== 'undefined' ? checkboxNode.checked : false;
      var style = direction === 'horizontal' ? { whiteSpace: 'nowrap', display: 'inline', height: '30px' } : { whiteSpace: 'nowrap', display: 'block', height: '30px' };

      var expand = this.getInnerLevelIcon(id, checkboxNode);
      var input = _react2.default.createElement('input', {
        defaultChecked: defaultChecked,
        key: filterName + '-' + checkboxNode.id,
        type: multipleSelect ? 'checkbox' : 'radio',
        id: id,
        'data-qa': testId + id,
        name: multipleSelect ? name + '_' + id : id,
        onChange: this.handleCheckBoxClick.bind(this, checkboxNode)
      });

      var label = _react2.default.createElement(
        'label',
        { htmlFor: id, title: hoverText.split('>').length > 1 ? hoverText : '' },
        toolTipPlacement !== 'none' ? _react2.default.createElement(_MozartToolTip2.default, {
          key: 'binary_checkbox_tooltip',
          node: _react2.default.createElement(
            'span',
            null,
            checkboxNode.name
          ),
          data: hoverText.split('>').length > 1 && _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              hoverText
            )
          ),
          placement: toolTipPlacement ? toolTipPlacement : 'left'
        }) : _react2.default.createElement(
          'span',
          null,
          checkboxNode.name
        ),
        !expandable ? this.getInnerLevelIcon(id, checkboxNode) : ''
      );
      if (excludeSelect.indexOf(checkboxNode.id) !== -1) {
        return '';
      }
      if (!expandable) {
        return multipleSelect ? _react2.default.createElement(
          _MozartCheckBox2.default,
          { key: checkboxNode.id, style: style },
          input,
          label
        ) : _react2.default.createElement(
          _MozartRadio2.default,
          { key: checkboxNode.id, style: style },
          input,
          label
        );
      } else {
        style.left = checkboxNode.left;
        return multipleSelect ? _react2.default.createElement(
          _MozartCheckBox2.default,
          { key: checkboxNode.id + '_' + checkboxNode.parent.id + '_' + checkboxNode.name, style: style },
          expand,
          input,
          label
        ) : _react2.default.createElement(
          _MozartRadio2.default,
          { key: checkboxNode.id + '_' + checkboxNode.parent.id + '_' + checkboxNode.name, style: style },
          expand,
          input,
          label
        );
      }
    }
  }, {
    key: 'getCustomInput',
    value: function getCustomInput() {
      var _this5 = this;

      var _props4 = this.props,
          customName = _props4.customName,
          customValue = _props4.customValue,
          filterName = _props4.filterName,
          testId = _props4.testId;

      var id = filterName ? testId + '_' + filterName.toLowerCase().split(' ').join('_') : testId;

      var input = _react2.default.createElement('input', {
        defaultChecked: customValue,
        ref: 'custom',
        key: filterName + '_custom_' + customValue,
        type: 'checkbox',
        id: 'custom',
        'data-qa': 'custom_' + id + '_' + testId,
        name: 'custom',
        onChange: function onChange() {
          _this5.props.updateCustom();
        }
      });
      var label = _react2.default.createElement(
        'label',
        { htmlFor: 'custom', title: customName },
        customName
      );
      return _react2.default.createElement(
        MozartCheckboxCustom,
        { key: customValue },
        _react2.default.createElement(
          _MozartCheckBox2.default,
          null,
          input,
          label
        )
      );
    }
  }, {
    key: 'getOrderCheckBoxesByNameKey',
    value: function getOrderCheckBoxesByNameKey(filter) {
      var keysinorder = [];
      var keysObj = [];
      if (filter && filter.children && filter.children !== null) {
        Object.keys(filter.children).forEach(function (key) {
          keysObj.push(filter.children[key]);
        });
      }
      keysObj.sort(function (item1, item2) {
        var item1_ = '';
        var item2_ = '';
        if (item1.index && item2.index) {
          item1_ = item1.index;
          item2_ = item2.index;
        } else {
          item1_ = item1.name;
          item2_ = item2.name;
        }
        if (item1_ > item2_) {
          return 1;
        }
        if (item1_ < item2_) {
          return -1;
        }
        return 0;
      });
      keysObj.forEach(function (item) {
        keysinorder.push(item.id);
      });
      return keysinorder;
    }
  }, {
    key: 'getCheckBoxBreadCrums',
    value: function getCheckBoxBreadCrums() {
      var filter = this.props.filter;

      var hierarchy = [filter];
      var checkbox = filter;

      while (checkbox && checkbox.parentId !== null && checkbox.parent) {
        hierarchy.push(checkbox.parent);
        checkbox = checkbox.parent;
      }
      return hierarchy.length > 1 ? _react2.default.createElement(_MozartBreadCrum2.default, {
        style: { fontSize: '12px' },
        data: hierarchy.reverse(),
        onClick: this.handleBreadCrumClick.bind(this) }) : '';
    }
  }, {
    key: 'getHoverText',
    value: function getHoverText(filter) {
      var filterData = Object.assign({}, filter);
      var hierarchy = [];
      var hover = [];
      while (filterData.parent) {
        hierarchy.push(filterData.parent);
        filterData = filterData.parent;
      }
      hierarchy.forEach(function (item) {
        hover.push(item.name);
      });
      return hover.reverse().join(' > ');
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput() {
      var _this6 = this;

      var _props5 = this.props,
          filter = _props5.filter,
          testId = _props5.testId;

      return _react2.default.createElement(
        MozartFilterSearch,
        null,
        _react2.default.createElement('input', {
          onChange: (0, _utils.debounce)(function () {
            _this6.search();
            if (_this6.refs.list) {
              _this6.refs.list.forceUpdateGrid();
            }
          }, 800).bind(this),
          type: 'text',
          placeholder: 'Search',
          ref: 'search',
          id: 'binary_checkbox_search_' + filter.name,
          'data-qa': 'binary_checkbox_search_' + filter.name + '_' + testId,
          maxLength: 80,
          defaultValue: this.state.search_value,
          addonBefore: _react2.default.createElement('span', { className: 'icon-Search' })
        }),
        _react2.default.createElement('span', { className: 'icon-Search' })
      );
    }
  }, {
    key: 'search',
    value: function search() {
      var _this7 = this;

      var value = this.refs.search ? this.refs.search.value : '';
      this.setState({ search_value: value.trim() }, function () {
        _this7.scrollTop = 0;
        if (value.trim().length === 0) {
          _this7.alignElements();
          _this7.props.resetSearch();
        }
        if (value.length > 2) {
          _this7.props.searchFilter(_this7.state.search_value);
        }
      });
    }
  }, {
    key: 'alignChildElements',
    value: function alignChildElements(filter, currLeft) {
      var _this8 = this;

      if (typeof filter.left !== 'undefined') {
        currLeft = currLeft + 40;
        filter.left = currLeft;
        if (filter.children) {
          Object.keys(filter.children).forEach(function (child) {
            filter.children[child] = _this8.alignChildElements(filter.children[child], currLeft);
          });
        }
      }
      return filter;
    }
  }, {
    key: 'alignElements',
    value: function alignElements() {
      var _this9 = this;

      var filter = this.props.filter;

      if (filter.children) {
        Object.keys(filter.children).forEach(function (child) {
          if (filter.children[child].children) {
            Object.keys(filter.children[child].children).forEach(function (subChild) {
              filter.children[child].children[subChild] = _this9.alignChildElements(filter.children[child].children[subChild], 0);
            });
          }
        });
      }
    }
  }, {
    key: 'handleBreadCrumClick',
    value: function handleBreadCrumClick(filter) {
      this.props.updateFilter(filter);
    }
  }, {
    key: 'handleInnerLevelClick',
    value: function handleInnerLevelClick(filterClicked) {
      var _this10 = this;

      var expandable = this.props.expandable;

      if (this.refs.search) {
        this.refs.search.value = '';
      }
      this.setState({
        search_value: ''
      }, function () {
        if (expandable) {
          var rootFilter = filterClicked;
          filterClicked.expanded = !filterClicked.expanded;
          if (filterClicked.expanded) {
            var currTree = [];
            while (rootFilter.parent && rootFilter.filter !== null) {
              rootFilter = rootFilter.parent;
              rootFilter.expanded = true;
              currTree.push(rootFilter);
            }

            var currLeft = 40;
            currTree.reverse().forEach(function (item) {
              Object.keys(item.children).forEach(function (key) {
                if (key !== item.id && item.parent && item.parent !== null) {
                  item.children[key].left = currLeft;
                }
              });
              if (item.id && item.id !== 0 && item.parentId !== null) {
                currLeft = currLeft + 40;
              }
            });
            Object.keys(filterClicked.children).forEach(function (key) {
              filterClicked.children[key].left = currLeft;
            });
          }
          _this10.props.updateFilter(filterClicked);
        } else {
          _this10.props.updateFilter(filterClicked);
        }
      });
    }
  }, {
    key: 'uncheckAll',
    value: function uncheckAll() {
      var _this11 = this;

      if (this.refs.search) {
        this.refs.search.value = '';
      }
      this.setState({
        search_value: ''
      }, function () {
        _this11.props.uncheckAll();
        _this11.search();
        if (_this11.refs.list) {
          _this11.refs.list.forceUpdateGrid();
        }
      });
    }
  }, {
    key: 'checkAll',
    value: function checkAll() {
      var _this12 = this;

      if (this.refs.search) {
        this.refs.search.value = '';
      }
      this.setState({
        search_value: ''
      }, function () {
        _this12.props.checkAll();
        _this12.search();
        if (_this12.refs.list) {
          _this12.refs.list.forceUpdateGrid();
        }
      });
    }
  }, {
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(filter, event) {
      var _this13 = this;

      var _props6 = this.props,
          name = _props6.name,
          infinite = _props6.infinite,
          checkFilter = _props6.checkFilter;

      if (checkFilter) {
        checkFilter(name, filter, event.target.checked, function () {
          if (infinite) {
            _this13.list = _this13.getCheckBoxesList();
            _this13.refs.list.forceUpdateGrid();
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          filter = _props7.filter,
          expandable = _props7.expandable,
          updateCustom = _props7.updateCustom,
          name = _props7.name,
          search = _props7.search,
          clearall = _props7.clearall,
          themeId = _props7.themeId,
          selectAll = _props7.selectAll;

      var CHECKBOX_RENDER = this.getCheckBoxes();
      var BREADCRUMS_RENDER = !expandable ? this.getCheckBoxBreadCrums() : [];

      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        filter && search && this.getSearchInput(),
        filter && updateCustom && this.getCustomInput(),
        filter && !expandable && _react2.default.createElement(
          BREADCRUMS,
          null,
          BREADCRUMS_RENDER
        ),
        filter && _react2.default.createElement(
          MozartfilterCheckboxContainer,
          { key: name.split(' ').join(''), style: { overflow: 'inherit', maxHeight: 'none' } },
          CHECKBOX_RENDER.length === 0 ? 'No Results Found !' : _react2.default.createElement(
            'div',
            { key: Math.random() },
            CHECKBOX_RENDER
          ),
          CHECKBOX_RENDER.length < 52 && this.props.showAll && _react2.default.createElement(
            'p',
            { className: this.styles.show_all, onClick: this.props.showAll.bind(this) },
            'Show More'
          )
        ),
        filter && clearall && _react2.default.createElement(
          ClearAll,
          {
            id: 'binary_filter_clearall_' + name.split(' ').join('_').toLowerCase(),
            onClick: this.uncheckAll.bind(this) },
          'Clear'
        ),
        filter && selectAll && _react2.default.createElement(
          CheckAll,
          {
            id: 'binary_filter_selectal',
            onClick: this.checkAll.bind(this) },
          'Select All'
        ),
        typeof filter === 'undefined' && _react2.default.createElement(
          'p',
          null,
          'No Data'
        )
      );
    }
  }]);

  return MozartInputBox;
}(_react.Component);

MozartInputBox.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  filter: _propTypes2.default.object.isRequired,
  excludeSelect: _propTypes2.default.array,
  /** if none tooltip is hidden. Available options: right/left/top/bottom */
  toolTipPlacement: _propTypes2.default.string,

  customName: _propTypes2.default.string,
  customValue: _propTypes2.default.bool,
  updateCustom: _propTypes2.default.func,
  direction: _propTypes2.default.string,
  border: _propTypes2.default.bool,

  infiniteWidth: _propTypes2.default.string,
  infiniteHeight: _propTypes2.default.string,

  updateFilter: _propTypes2.default.func.isRequired,
  checkFilter: _propTypes2.default.func.isRequired,
  searchFilter: _propTypes2.default.func.isRequired,
  showAll: _propTypes2.default.func,
  resetSearch: _propTypes2.default.func.isRequired,
  uncheckAll: _propTypes2.default.func.isRequired,
  search: _propTypes2.default.bool,
  clearall: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  multipleSelect: _propTypes2.default.bool,
  expandable: _propTypes2.default.bool,
  selectAll: _propTypes2.default.bool,
  checkAll: _propTypes2.default.func
};
MozartInputBox.defaultProps = {
  name: '',
  testId: 'MozartInputBox',
  themeId: 'MozartInputBox',
  search: false,
  clearall: true,
  direction: 'vertical',
  border: true,
  excludeSelect: [],
  infinite: false,
  multipleSelect: true,
  expandable: false,
  selectAll: false
};
exports.default = MozartInputBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartInputBox/MozartInputBox.js
// module id = 726
// module chunks = 1